import { Api } from "laravel-request";

export type ParserQueueInfo = {
    total?: number;
    pending?: number;
    processing?: number;
    completed?: number;
    failed?: number;
};

export type ParserPm2Process = {
    id?: number;
    name?: string;
    status?: string;
    uptime?: number;
    restarts?: number;
    memory?: number;
    cpu?: number;
    pid?: number;
    uptimeFormatted?: string;
};

export type ParserPm2Info = {
    available?: boolean;
    processes?: ParserPm2Process[];
    totalRuntime?: number;
    totalRuntimeFormatted?: string;
};

export type ParserActiveProcessParams = {
    userId?: number;
    jobId?: string;
    accounts?: string;
    [key: string]: any;
};

export type ParserActiveProcess = {
    id?: string;
    file?: string;
    status?: string;
    startedAt?: string;
    duration?: number;
    durationFormatted?: string;
    params?: ParserActiveProcessParams;
};

export type ParserHealthServer = {
    uptime?: number;
    uptimeFormatted?: string;
    activeTasks?: number;
    maxConcurrent?: number;
};

export type ParserHealthBody = {
    status?: string;
    timestamp?: string;
    server?: ParserHealthServer;
    activeProcesses?: ParserActiveProcess[];
    totalRuntime?: number;
    totalRuntimeFormatted?: string;
    pm2?: ParserPm2Info;
    queue?: ParserQueueInfo;
};

export type ParserProgressSlice = {
    total?: number;
    processed?: number;
    remaining?: number;
    percentage?: number;
    estimated?: number;
};

export type ParserProgressBody = {
    isRunning?: boolean;
    accounts?: ParserProgressSlice;
    dates?: ParserProgressSlice;
    requests?: ParserProgressSlice;
};

export type ParserHealthIndexData = {
    health?: any;
    progress?: any;
    source?: string;
    cached_at?: string;
};

export type ParserHealthWsPayload = {
    health?: any;
    progress?: any;
    cached_at?: string;
};

type LaravelRestResponse<T> = {
    data?: T;
    result?: string;
};

function extractData<T>(response: LaravelRestResponse<T> | T | undefined): T | undefined {
    if (response == null || typeof response !== "object") {
        return response as T | undefined;
    }
    if ("data" in response && (response as LaravelRestResponse<T>).data !== undefined) {
        return (response as LaravelRestResponse<T>).data as T;
    }
    return response as T;
}

export function fetchParserHealthIndex(onSuccess: (data: ParserHealthIndexData) => void, onError?: (message?: string) => void) {
    Api.get("parser-health", "index")
        .withoutNotify()
        .call(
            (response: LaravelRestResponse<ParserHealthIndexData>) => {
                const data = extractData(response);
                if (data) onSuccess(data);
                else onError?.("Пустой ответ");
            },
            (_xhr: any, responseData?: { message?: string; meta?: { message?: string } }) => {
                onError?.(responseData?.message || responseData?.meta?.message || "Ошибка запроса");
            }
        );
}

export function fetchParserHealthRaw(onSuccess: (data: any) => void, onError?: (message?: string) => void) {
    Api.get("parser-health", "health-raw")
        .withoutNotify()
        .call(
            (response: LaravelRestResponse<any>) => {
                const data = extractData(response);
                onSuccess(data ?? response);
            },
            (_xhr: any, responseData?: { message?: string }) => {
                onError?.(responseData?.message || "Ошибка запроса");
            }
        );
}

export function fetchParserHealthProgress(onSuccess: (data: any) => void, onError?: (message?: string) => void) {
    Api.get("parser-health", "progress")
        .withoutNotify()
        .call(
            (response: LaravelRestResponse<any>) => {
                const data = extractData(response);
                onSuccess(data ?? response);
            },
            (_xhr: any, responseData?: { message?: string }) => {
                onError?.(responseData?.message || "Ошибка запроса");
            }
        );
}
